// import { useMeeting } from "@videosdk.live/react-sdk";
import React, { useMemo, useEffect, useRef } from "react";
import  ParticipantView  from "./ParticipantView.js";
import "./css/ParticipantGrid.css"
import { useState } from "react";
// import { useMeeting } from "@videosdk.live/react-sdk";
import Nextarrow from "./images/Nextarrow.svg";
import { useMeeting } from "@videosdk.live/react-sdk";
const MemoizedParticipant = React.memo(
  ParticipantView, 
  (prevProps, nextProps) => {
    return (prevProps.participantId === nextProps.participantId && prevProps.changeStreamQuality === nextProps.changeStreamQuality && prevProps.fullscreenParticipantId === nextProps.fullscreenParticipantId);
  }
);

function ParticipantGrid({ participantIds, isPresenting, comingFromScreenShare }) {
  const sideBarMode = false; // If this comes from context, adjust accordingly
  const isMobile = false // Assuming this hook exists
  const mMeeting = useMeeting(); // Assuming this hook exists
  const [changeStreamQuality, setChangeStreamQuality] = useState(false)
  const [fullscreenParticipantId, setFullscreenParticipantId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [webcamStatuses, setWebcamStatuses] = useState(1);
  const [containerDimensions, setContainerDimensions] = useState({ width: 0, height: 0 });
  const [teacherActiveDevices, setTeacherActiveDevices] = useState({});
  const url = window.location;
  const urlParams = new URLSearchParams(url.search);
  const sahUser = urlParams.get("sahUser") || false;
  const pageSize = 25;
  const totalPages = Math.ceil(participantIds.length / pageSize);
  const containerRef = useRef(null);



  const visibleTeacherList = useMemo(() => {
    

      const teacherGroups = {};
      const nonTeacherIds = [];
      const localParticipantId = mMeeting.localParticipant?.id;
      
      participantIds.forEach(id => {
        if (id === localParticipantId) {
          return;
        }
        
        if (id.includes("teacher")) {
          const uuid = id.split("teacher-")[0];
          
          if (!teacherGroups[uuid]) {
            teacherGroups[uuid] = [];
          }
          teacherGroups[uuid].push(id);
        } else {
          nonTeacherIds.push(id);
        }
      });
      
      const filteredTeacherIds = {};
      
      Object.entries(teacherGroups).forEach(([uuid, teacherIds]) => {
        const devicesWithCameraOn = teacherIds.filter(id => 
          mMeeting.participants.get(id)?.webcamOn
        );
        
        if (devicesWithCameraOn.length > 0) {
          filteredTeacherIds[devicesWithCameraOn[0]] = true;
        } 
        else if (teacherActiveDevices[uuid] && teacherIds.includes(teacherActiveDevices[uuid])) {
          filteredTeacherIds[teacherActiveDevices[uuid]] = true;
        }
        else {
          const deviceWithMicOn = teacherIds.find(id => 
            mMeeting.participants.get(id)?.micOn
          );
          
          if (deviceWithMicOn) {
            filteredTeacherIds[deviceWithMicOn] = true;

            // filteredTeacherIds.push(deviceWithMicOn);
          } else if (teacherIds.length > 0) {
            filteredTeacherIds[teacherIds[0]] = true;
            // filteredTeacherIds.push(teacherIds[0]);
          }
        }
      });
      
      
      
      // console.log("Filtered teacher participants:", visibleIds);
      return filteredTeacherIds;

  }, [participantIds, mMeeting.localParticipant?.id, mMeeting.participants, teacherActiveDevices,
    webcamStatuses,
    // Force re-render when any participant's webcam status changes
    Array.from(mMeeting.participants.entries())
      .map(([id, p]) => `${id}:${p.webcamOn}`)
      .join("|")]);
 
    const visibleParticipantIds = useMemo(() => {    
      if (sahUser) {      
        console.log("visible teacher list",visibleTeacherList);
        return participantIds.filter(id => id?.includes("teacher") && visibleTeacherList?.[id]);
      }
      return participantIds;
    }, [participantIds, sahUser, visibleTeacherList]);

  const hiddenParticipants1 = useMemo(() => 
    visibleParticipantIds.slice(0, (currentPage - 1) * pageSize) || [],
    [visibleParticipantIds, currentPage, pageSize]
  );
  
  const hiddenParticipants2 = useMemo(() => 
    visibleParticipantIds.slice(currentPage * pageSize, visibleParticipantIds.length) || [],
    [visibleParticipantIds, currentPage, pageSize]
  );
  
  const totalHiddenParticipant = useMemo(() => {
    if (sahUser) {
      console.log("testing visiible idsssss",visibleTeacherList)
      let nonTeacherParticipantsAndHiddenTeacher = participantIds.filter(id => !id?.includes("teacher") || (id?.includes("teacher") && !visibleTeacherList[id]));
        console.log("nonTeachedr" , nonTeacherParticipantsAndHiddenTeacher);
        
        return nonTeacherParticipantsAndHiddenTeacher;
    } else {
        return [...hiddenParticipants1, ...hiddenParticipants2];
    }
}, [hiddenParticipants1, hiddenParticipants2, participantIds, sahUser,visibleTeacherList]);

const audioOnlyParticipants = useMemo(() => {
  if (sahUser) {
    // Audio-only participants are all nonteachers
    return participantIds.filter(id => !id?.includes("teacher") || (id?.includes("teacher") && !visibleTeacherList[id]));
  }
  return [];
}, [participantIds, sahUser]);

useEffect(() => {
    const teacherGroups = {};
    
    participantIds.forEach(id => {
      if (id.includes("teacher")) {
        const uuid = id.split("teacher-")[0];
        if (!teacherGroups[uuid]) {
          teacherGroups[uuid] = [];
        }
        teacherGroups[uuid].push(id);
      }
    });
    
    const updatedTeacherDevices = {...teacherActiveDevices};
    let hasChanges = false;
    
    Object.entries(teacherGroups).forEach(([uuid, deviceIds]) => {
      console.log("deviceIds",deviceIds);
      
      const devicesWithCameraOn = deviceIds.filter(id => 
        mMeeting.participants.get(id)?.webcamOn
      );
      
      if (devicesWithCameraOn.length > 0) {
        if (updatedTeacherDevices[uuid] !== devicesWithCameraOn[0]) {
          updatedTeacherDevices[uuid] = devicesWithCameraOn[0];
          hasChanges = true;
        }
      } else {
        const deviceWithMicOn = deviceIds.find(id => 
          mMeeting.participants.get(id)?.micOn
        );
        
        if (deviceWithMicOn) {
          if (updatedTeacherDevices[uuid] !== deviceWithMicOn) {
            updatedTeacherDevices[uuid] = deviceWithMicOn;
            hasChanges = true;
          }
        } else if (deviceIds.length > 0 && (!updatedTeacherDevices[uuid] || !deviceIds.includes(updatedTeacherDevices[uuid]))) {
          updatedTeacherDevices[uuid] = deviceIds[0];
          hasChanges = true;
        }
      }
    });
    
    if (hasChanges) {
      setTeacherActiveDevices(updatedTeacherDevices);
    }
}, [participantIds, mMeeting.participants, teacherActiveDevices]);

  // Navigation functions
  const nextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
  };
  
  const prevPage = () => {
    if (currentPage > 1) setCurrentPage((prev) => prev - 1);
  };
  const paginatedParticipants = useMemo(() => {
 
    return visibleParticipantIds.slice((currentPage - 1) * pageSize, currentPage * pageSize);
  }, [visibleParticipantIds, currentPage, pageSize]);
// Calculate grid dimensions

  useEffect(() => {
    if (paginatedParticipants?.length > 6) {
      setChangeStreamQuality(!changeStreamQuality)
    }
  }, [paginatedParticipants?.length])
  
  // Calculate optimal participants per row based on count
  // ensuring we never exceed 5 rows
  const perRow = useMemo(() => {
    const count = paginatedParticipants.length;
    const maxRows = 5;
    
    if (isMobile || isPresenting) {
      if (count < 3) return 1;
      else if (count < 4) return 2;
      else return 3;
    } else {
      if (count === 0) return 0;
      else if (count === 1) return 1;
      else if (count <= 4) return 2;
      else if (count <= 9) return 3;
      else if (count <= 16) return 4;
      else if (count <= 25) return 5;
      
      return Math.ceil(count / maxRows);
    }
  }, [paginatedParticipants.length, isMobile, isPresenting]);
  
  const participantRows = useMemo(() => {
    const rows = [];
    const maxRows = 5; 
    const actualRows =isMobile?Math.ceil(paginatedParticipants.length / perRow): Math.min(maxRows, Math.ceil(paginatedParticipants.length / perRow));
    
    const participantsPerRow = isMobile
  ? (paginatedParticipants.length === 2 ? 1 : 2)
  : Math.ceil(paginatedParticipants.length / actualRows);
  
    for (let i = 0; i < actualRows; i++) {
      // Calculate start and end indices for each row
      const startIdx = i * participantsPerRow;
      const endIdx = Math.min(startIdx + participantsPerRow, paginatedParticipants.length);
      
      // Get participants for this row
      const rowParticipants = paginatedParticipants.slice(startIdx, endIdx);
      const isLastRow = i === actualRows - 1;
      
      rows.push({ rowParticipants, isLastRow });
    }
    
    return rows;
  }, [paginatedParticipants, perRow]);
  
  // CSS classes for grid container based on participant count
  const getContainerClasses = useMemo(() => {
    const count = paginatedParticipants.length;
    
    let paddingClasses = "px-0-md";
    
    if (!sideBarMode && !isPresenting) {
      if (count === 1) paddingClasses = "px-16-md py-2-md";
      else if (count <= 4) paddingClasses = "px-16-md py-8-md";
      else if (count <= 9) paddingClasses = "px-16-md py-4-md";
      else if (count <= 25) paddingClasses = "px-14-md";
      else paddingClasses = "px-8-md"; // Less padding for higher density layouts
    }
    
    const arrowSpaceClasses = `
      ${(currentPage > 1 && hiddenParticipants1?.length > 0) ? "LeftArrowSpace" : ""}
      ${(currentPage < totalPages && hiddenParticipants2?.length > 0) ? "RightArrowSpace" : ""}
    `;
    
    return {
      mainContainer: `flex flex-col flex-grow m-3 items-center justify-center mr20 MobParticipantScroll ${isPresenting ? "isPresent" : ""} ${paddingClasses}`,
      innerContainer: `flex flex-col w-full h-full Gap5 ${arrowSpaceClasses}`
    };
  }, [paginatedParticipants.length, sideBarMode, isPresenting, currentPage, totalPages, hiddenParticipants1, hiddenParticipants2]);
  
  // Calculate CSS for individual participants based on count and row config
  const getParticipantStyles = useMemo(() => {
    const count = paginatedParticipants.length;
    
    if (isPresenting) {
      if (count === 1) return "h-48-md w-44-md w-52-xl h-48-xl max-w-7xl-md max-w-1480px-2xl Video-Item-1";
      if (count === 2) return "w-44-md w-56-xl max-w-lg-md max-w-2xl-2xl";
      return "w-44-md w-48-xl max-w-lg-md max-w-2xl-2xl";
    }
    
    if (count === 1) return "w-full max-w-7xl-md max-w-1480px-2xl Video-Item-1";
    if (count > 25) return "grid-participant"; // Custom class for high-density grid
    return "max-w-lg-md max-w-2xl-2xl";
  }, [paginatedParticipants.length, isPresenting]);
  let wakeLock = null;

const requestWakeLock = async () => {
  try {
    wakeLock = await navigator.wakeLock.request('screen');
    wakeLock.addEventListener('release', () => {
      console.log('Screen Wake Lock released');
    });
    console.log('Screen Wake Lock acquired');
  } catch (err) {
    console.error(`${err.name}, ${err.message}`);
  }
};

function getBoxSize(rows, cols, containerWidth, containerHeight, bottomBarHeight = 100) {
  console.log("containerWidth",containerWidth);
  console.log("containerHeight",containerHeight);
  console.log("bottomBarHeight",bottomBarHeight);
  console.log("rows",rows);
  console.log("cols",cols); 
  const usableHeight = containerHeight - bottomBarHeight;
  const maxBoxWidth = containerWidth / cols;
  const maxBoxHeight = usableHeight / rows;
  
 
  const aspectRatio = 16 / 9;
 
  let boxWidth = maxBoxHeight * aspectRatio;
  let boxHeight = maxBoxHeight;
 
  if (boxWidth > maxBoxWidth) {
    boxWidth = maxBoxWidth;
    boxHeight = maxBoxWidth / aspectRatio;
  }
 
  return { boxWidth, boxHeight };
}


  // Calculate which participants to show and which to hide
  
const gridLayout = useMemo(() => {
  const count = paginatedParticipants.length;
  const cols = perRow;
  const rows = Math.ceil(count / cols);
  
  return { rows, cols, count };
}, [paginatedParticipants.length, perRow]);

// Calculate box sizes using the provided formula
const boxSizing = useMemo(() => {
 // window.alert("containerDimensions" + containerDimensions.height);
  if (containerDimensions.width === 0 || containerDimensions.height === 0) {
    return { boxWidth: 200, boxHeight: 113 }; // Default fallback
  }
  
  const { rows, cols } = gridLayout;
  const { boxWidth, boxHeight } = getBoxSize(
    rows, 
    cols, 
    sideBarMode==null? containerDimensions.width - 80:containerDimensions.width-80, // Account for padding
    containerDimensions.height,
    100 // Bottom bar height
  );
  
  return { boxWidth, boxHeight };
}, [containerDimensions.height, containerDimensions.width, gridLayout,sideBarMode]);

useEffect(() => {
  const updateDimensions = () => {
    if (containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect();
      setContainerDimensions({
        width: rect.width,
        height: rect.height
      });
    }
  };

  updateDimensions();
  
  // Use ResizeObserver for more accurate container size detection
  let resizeObserver;
  if (containerRef.current && window.ResizeObserver) {
    resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const rect = entry.target.getBoundingClientRect();
        setContainerDimensions({
          width: rect.width,
          height: rect.height
        });
      }
    });
    resizeObserver.observe(containerRef.current);
  }
  
  // Fallback to window resize event
 // window.addEventListener('resize', updateDimensions);
  
  // Also listen for orientation change on mobile devices
  window.addEventListener('orientationchange', updateDimensions);
  
  return () => {
    if (resizeObserver) {
      resizeObserver.disconnect();
    }
   // window.removeEventListener('resize', updateDimensions);
    window.removeEventListener('orientationchange', updateDimensions);
  };
}, [sideBarMode]);

// Grid container styles
const gridContainerStyles = useMemo(() => {
  const { rows, cols } = gridLayout;
  const { boxWidth, boxHeight } = boxSizing;
  
  return {
    display: 'grid',
    gridTemplateColumns: `repeat(${cols}, ${boxWidth}px)`,
    gridTemplateRows: `repeat(${rows}, ${boxHeight}px)`,
    gap: '8px',
    justifyContent: 'center',
    alignContent: 'center',
    width: '100%',
    height: '100%',
    // maxHeight: `${containerDimensions.height - 100}px`, // Reserve 100px for bottom bar
    overflow: 'hidden'
  };
}, [gridLayout, boxSizing, containerDimensions]);

const participantBoxStyles = useMemo(() => {
  const { boxWidth, boxHeight } = boxSizing;
  
  return {
    width: `${boxWidth}px`,
    height: `${boxHeight}px`,
    aspectRatio: '16/9',
    overflow: 'hidden',
    borderRadius: '8px'
  };
}, [boxSizing]);


const handleWebcamStatusChange = (participantId, webcamOn) => {
  console.log("webcamStatuses-teacher",participantId)
  if(participantId?.includes("teacher")){
    console.log("webcamStatuses",participantId?.split('-teacher-')?.[0],webcamOn)
  setWebcamStatuses(prev => ({
    ...prev,
    [participantId?.split('-teacher-')?.[0]]: webcamOn
  }));
}
};

console.log("webcamStatuses",webcamStatuses);

  // Pagination configuration - fixed at 50 participants per page



// Call this function when the call starts
requestWakeLock();
document.addEventListener('visibilitychange', async () => {
  if (wakeLock !== null && document.visibilityState === 'visible') {
    await requestWakeLock();
  }
});


  
  return (
    <>
      <div ref={containerRef} className={getContainerClasses.mainContainer}>
        {/* Previous page button */}
        {currentPage > 1 && hiddenParticipants1?.length > 0 && (
          <button 
            onClick={prevPage}
            aria-label="Previous page"
            className="Controllbtn PreItem"
          >
            <img src={Nextarrow} alt="Previous Arrow" />
          </button>
        )}
        
        {/* Next page button */}
        {currentPage < totalPages && hiddenParticipants2?.length > 0 && (
          <button 
            onClick={nextPage}
            className="Controllbtn NextItem"
            aria-label="Next page"
          >
            <img src={Nextarrow} alt="Next Arrow" />
          </button>
        )}
        
        {/* Participant grid */}
        <div className={getContainerClasses.innerContainer}>
        {fullscreenParticipantId ? (
            // Fullscreen mode
            <div className="w-full h-full flex items-center justify-center">
              <div className="fullscreen-video-container">
                <div className="fullscreen-participant-card">
                  <MemoizedParticipant 
                    participantId={fullscreenParticipantId} 
                    changeStreamQuality={changeStreamQuality} 
                    fullscreenParticipantId={fullscreenParticipantId} 
                    setFullscreenParticipantId={setFullscreenParticipantId}
                    cardWidth={containerDimensions.width * 0.9}
                    cardHeight={containerDimensions.height * 0.8}
                    onWebcamStatusChange={handleWebcamStatusChange}
                  />
                </div>
              </div>
            </div>
          ) : (
            // Grid mode with dynamic sizing
            <div style={gridContainerStyles}>
              {paginatedParticipants.map((participantId) => (
                <div
                  key={`participant_${participantId}`}
                  style={participantBoxStyles}
                >
                  <MemoizedParticipant 
                    participantId={participantId} 
                    changeStreamQuality={changeStreamQuality} 
                    fullscreenParticipantId={fullscreenParticipantId} 
                    setFullscreenParticipantId={setFullscreenParticipantId} 
                    cardWidth={boxSizing.boxWidth}
                    cardHeight={boxSizing.boxHeight}
                    onWebcamStatusChange={handleWebcamStatusChange}
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      
      {/* Hidden participants (to keep connections active) */}
      {totalHiddenParticipant?.map(id => (
        <div key={`hidden_${id}`} style={{ display: "none" }}>
          <MemoizedParticipant participantId={id} hiddenVideo={true} onWebcamStatusChange={handleWebcamStatusChange}/>
        </div>
      ))}
      {audioOnlyParticipants.map(id => (
        <div key={`audio_only_${id}`} style={{ display: "none" }}>
          <MemoizedParticipant 
            participantId={id} 
            hiddenVideo={true}
            audioOnly={true}
            onWebcamStatusChange={handleWebcamStatusChange}
          />
        </div>
      ))}
    </>
  );
}

export default ParticipantGrid;

// Add these CSS classes to your stylesheet:

// Helper function to get participant container styling
function getParticipantStyles(participantCount, isPresenting) {
  if (isPresenting) {
    if (participantCount === 1) return "h-48-md w-44-md w-52-xl h-48-xl max-w-7xl-md max-w-1480px-2xl Video-Item-1";
    if (participantCount === 2) return "w-44-md w-56-xl max-w-lg-md max-w-2xl-2xl";
    return "w-44-md w-48-xl max-w-lg-md max-w-2xl-2xl";
  }
  
  if (participantCount === 1) return "w-full max-w-7xl-md max-w-1480px-2xl Video-Item-1";
  return "w-full max-w-lg-md max-w-2xl-2xl";
}




export const MemoizedParticipantGrid = React.memo(
 ParticipantGrid,
// ParticipantGridShareScreen,
  (prevProps, nextProps) => {
    return (
      JSON.stringify(prevProps.participantIds) ===
        JSON.stringify(nextProps.participantIds) &&
      prevProps.isPresenting === nextProps.isPresenting && prevProps.comingFromScreenShare=== nextProps.comingFromScreenShare
    );
  }
);



// export default function ParticipantGridShareScreen({ participantIds, isPresenting }) {
//   const sideBarMode = false;
//   const isMobile = false;

//   return (
//     <div className="flex flex-col flex-grow m-3 items-center justify-center">
//       <div className="flex w-full h-full overflow-x-auto space-x-4 p-2 scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-200">
//         {participantIds.map((participantId) => (
//           <div
//             key={`participant_${participantId}`}
//             className="flex-shrink-0 w-40 h-40 md:w-48 md:h-48 lg:w-56 lg:h-56 flex items-center justify-center bg-gray-800 rounded-lg"
//           >
//             <MemoizedParticipant participantId={participantId} />
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }
// function ParticipantGridShareScreen({ participantIds, isPresenting }) {
//   const sideBarMode = false;
//   const isMobile = false

//   const perRow =
//     isMobile || isPresenting
//       ? participantIds.length < 4
//         ? 2
//         : participantIds.length < 9
//         ? 2
//         : 3
//       : participantIds.length < 5
//       ? 2
//       : participantIds.length < 7
//       ? 3
//       : participantIds.length < 9
//       ? 4
//       : participantIds.length < 10
//       ? 3
//       : participantIds.length < 11
//       ? 4
//       : 4;

//   console.log("per Row", participantIds, perRow);

//   return (
//     <>
//     <div className="flex flex-col flex-grow m-3 items-center justify-center">
//       <div className="flex w-full h-full overflow-x-auto space-x-4 p-2 scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-200">
//         {Array.from(
//           { length: Math.ceil(participantIds.length / perRow) },
//           (_, i) => (
//             <div
//               key={`participant-${i}`}
//               className={`flex flex-1 ${
//                 isPresenting
//                   ? participantIds.length === 1
//                     ? "justify-start items-start"
//                     : "items-center justify-center"
//                   : "items-center justify-center"
//               }`}
//             >
//               {participantIds
//                 .slice(i * perRow, (i + 1) * perRow)
//                 .map((participantId) => (
//                   <div
//                     key={`participant_${participantId}`}
//                     // className={`flex flex-1 ${
//                     //   isPresenting
//                     //     ? participantIds.length === 1
//                     //       ? "h-48-md w-44-md w-52-xl h-48-xl"
//                     //       : participantIds.length === 2
//                     //       ? "w-44-md w-56-xl"
//                     //       : "w-44-md w-48-xl"
//                     //     : "w-full"
//                     // } items-center justify-center h-full ${
//                     //   participantIds.length === 1
//                     //     ? "max-w-7xl-md max-w-1480px-2xl"
//                     //     : "max-w-lg-md max-w-2xl-2xl"
//                     // } overflow-clip overflow-hidden p-1`}
//                   >
//                     <MemoizedParticipant participantId={participantId} />
//                   </div>
//                 ))}
//             </div>
//           )
//         )}
//       </div>
//     </div>
//     </>
//   );
// }
